<template>
  <div>
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-card class="mx-auto box">
      <v-toolbar class="toolbar" flat dense>
        <v-toolbar-title>
          <strong>Worksheet Answer Key</strong>
        </v-toolbar-title>
      </v-toolbar>
      <br />
      <v-card max-width="700" class="mx-auto">
        <v-container fluid>
          <v-row dense align="center">
            <v-card elevation="0" class="mx-auto" max-width="300">
              <v-row align="center">
                <v-card-text class="text-h5 font-weight-bold">Academic Year&nbsp; : {{ this.ay }}</v-card-text>
              </v-row>
            </v-card>
            <v-card elevation="0" class="mx-auto" max-width="300">
              <v-row align="center">
                <v-card-text class="text-h5 font-weight-bold">Standard &nbsp; : {{ this.standard }}</v-card-text>
              </v-row>
            </v-card>
            <v-card elevation="0" class="mx-auto" max-width="300">
              <v-row align="center">
                <v-card-text class="text-h5 font-weight-bold">Division &nbsp; : {{ this.division }}</v-card-text>
              </v-row>
            </v-card>
            <v-card elevation="0" class="mx-auto" max-width="300">
              <v-row align="center">
                <v-card-text class="text-h5 font-weight-bold">Subject &nbsp; : {{ this.subject }}</v-card-text>
              </v-row>
            </v-card>
          </v-row>
        </v-container>
      </v-card>
      <br />
      <v-row align="center" justify="space-around">
        <v-btn color="primary" @click="OpenDialog" :disabled="isvalid == false ? true : false"> Add New Worksheet Answer
          Key </v-btn>
      </v-row><br>
      <v-row v-if="!isvalid" align="center" justify="space-around">
        <p v-if="!isvalid"><b>{{ Message }}</b></p>
      </v-row>

      <v-card>
        <v-card-title>
          <v-spacer></v-spacer>
          <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line
            hide-details></v-text-field>
        </v-card-title>

        <v-data-table :headers="headers" :items="worksheets_list" :search="search" class="mytable">
          <template v-slot:[`item.attachment`]="{ item }">
            <span style="color: grey" v-if="item.attachment == '-'">--</span>
            <a v-else target="_blank" :href="basepath + item.attachment">Attachment</a>
          </template>

          <template v-slot:[`item.url`]="{ item }">
            <a :href="item.url" target="_blank" v-if="item.url != '--'">
              <v-icon class="mr-2 v-icon-size" color="primary">mdi-login</v-icon>
            </a>
            <span v-else style="opacity: 0.5;">{{ item.url }}</span>
          </template>
          <template v-slot:[`item.assessmentTypeConfiglist`]="{ item }">
            <div v-for="(sub, i) in item.assessmentTypeConfiglist" :key="i">
              <span style="margin-left: 3px;"> {{ sub.name }} </span>

            </div>

          </template>
          <template v-slot:[`item.edit`]="{ item }">
            <div>
              <v-avatar style="" size="25" class="edit-avatar">
                <v-icon class="edit-v-icon mr-2" @click="editHomework(item)">edit</v-icon>
              </v-avatar>
            </div>
          </template>
          <template v-slot:[`item.delete`]="{ item }">
            <div>
              <v-avatar style="" size="25" class="delete-avatar">
                <v-icon color="red" class="delete-v-icon mr-2" @click="deleteHomework(item)"
                  :loading="delete_load">delete</v-icon>
              </v-avatar>
            </div>
          </template>
          <template v-slot:[`item.action`]="{ item }">
            <div>
              <v-btn depressed color="green" :disabled="item.total_submissions == 0"
                @click="evaluate(item)">Evaluation</v-btn>
            </div>
          </template>
        </v-data-table>
      </v-card>
      <v-dialog v-model="dialog" max-width="700px">
        <v-card>
          <v-card-title class="bg">
            <span class="headline">Add New Worksheet</span>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <v-icon color="error">*</v-icon>
                  <v-text-field v-model="title" label="Title" persistent-hint class="mt-n3" dense rounded outlined>
                  </v-text-field>
                </v-col>

                <v-col cols="12" sm="12" md="12">
                  <v-textarea dense rounded outlined v-model="description" label="Description"
                    persistent-hint></v-textarea>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6">
                  <v-icon color="error">*</v-icon>
                  <v-file-input v-model="new_file" label="Attachment" prepend-icon="mdi-paperclip" dense required
                    rounded outlined>
                  </v-file-input>
                </v-col>
                <v-col cols="6">
                  <v-icon color="error">*</v-icon>
                  <v-autocomplete color="#0F2027" dense rounded required v-model="assessment_type"
                    :items="assessment_type_list" item-text="name" item-value="id" label="Assessment Type" outlined
                    multiple />

                </v-col>
              </v-row>

            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" outlined text @click="dialog = false">Cancel</v-btn>
            <v-btn color="primary darken-1" dark @click="save"
              v-if="title && new_file && assessment_type.length != 0">Add</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!---->
      <v-dialog v-model="edit_dialog" max-width="650px">
        <v-card>
          <v-card-title>
            <span class="headline">Edit Worksheet</span>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <v-icon color="error">*</v-icon>
                  <br />
                  <br />
                  <v-text-field v-model="editedItem.title" label="Title" persistent-hint class="mt-n3" dense rounded
                    outlined>
                  </v-text-field>
                </v-col>

                <v-col cols="12" sm="12" md="12">
                  <v-textarea outlined v-model="editedItem.description" label="Description" persistent-hint dense
                    rounded></v-textarea>
                </v-col>

              </v-row>
              <v-row>
                <v-col cols="6">
                  <v-file-input v-model="new_file" label="Attachment" prepend-icon="mdi-paperclip"
                    :disabled="not_deleted" dense rounded outlined>
                  </v-file-input>
                </v-col>

                <v-col cols="6">
                  <v-autocomplete color="#0F2027" dense rounded required v-model="editedItem.assessmentTypeConfiglist"
                    :items="assessment_type_list" item-text="name" item-value="id" label="Assessment Type" outlined
                    return-object multiple />

                </v-col>

              </v-row>
              <template v-if="editedItem.attachment != '-'">
                <a target="_blank" :href="basepath + editedItem.attachment">Current Attachment</a>
                <v-btn text title="Delete attachment" :loading="delete_load" @click="deleteAttachment(editedItem)">
                  <v-icon color="red">mdi-window-close</v-icon>
                </v-btn>
              </template>

            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" outlined text @click="edit_dialog = false">Cancel</v-btn>
            <v-btn color="primary darken-1" dark @click="save_edited_homework" v-if="editedItem.title">Update</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card>
    <v-overlay :value="overlay">
      <v-progress-circular @click="OpenDialog" indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import axios from "axios";
import "@/assets/css/color.css";
import DatetimePicker from "vuetify-datetime-picker";
export default {
  components: { DatetimePicker },
  data() {
    return {
      isvalid: true, Message: null,
      org_id: null,
      not_deleted: true,
      not_deleted_modal_answer: true,
      delete_load: false,
      dialog: false,
      overlay: false,
      snackbar: false,
      search: "",
      snackbar_msg: "",
      color: "",
      snackbar: false,
      ay: null,
      standard: null,
      division: null,
      subject: null,
      worksheets_list: [],
      title: null,
      description: null,
      new_file: null,
      model_answer: null,
      basepath: null,
      // total_marks: 10,
      total_marks: 0,
      edit_dialog: false,
      is_assignment: false,
      headers: [
        {
          text: "Sr. No.",
          value: "srno",
          align: "center",
        },
        {
          text: "Post Date",
          value: "post_date",
          align: "center",
        },
        {
          text: "Title",
          value: "title",
          align: "center",
        },
        {
          text: "Description",
          value: "description",
          align: "center",
        },
        {
          text: "Assessment Type",
          value: "assessmentTypeConfiglist",
          align: "center",
        },
        {
          text: "Attachment",
          value: "attachment",
          align: "center",
        },
        {
          text: "Edit",
          value: "edit",
          align: "center",
        },
        {
          text: "Delete",
          value: "delete",
          align: "center",
        },
      ],
      editedItem: {
        worksheet_id: null,
        title: null,
        description: [],
        attachment: null,
        assessment_type_id: null,
        assessmentTypeConfiglist: [],
      },
      assessment_type_list: [], assessment_type: [],
    };
  },
  mounted() {
    this.getHomeWorkDetails();
    this.basepath = localStorage.getItem("awspath");
    this.org_id = localStorage.getItem("EPS-tenant");
  },
  methods: {
    deleteHomework(item) {
      if (!confirm("Are You Sure You Want To Delete This Worksheet?"))
        return;
      const data = {
        worksheet_id: item.worksheet_id
      };
      this.delete_load = true
      axios
        .post("/Homework/delete_worksheet", data)
        .then(res => {
          if (res.data.status == "YES") {
            this.showSnackbar("#4caf50", "Worksheet deleted successfully...");
            this.getHomeWorkDetails()
            this.delete_load = false
          } else if (res.data.status == "NO") {
            this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
          }
        })
        .catch(error => {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
          window.console.log(error);
        })
        .finally(() => {
          //close loader
          this.delete_load = false;
        });
    },
    save_edited_homework() {
      if (this.editedItem.title != null) {

        if (this.hasWhiteSpace(this.editedItem.title)) {
          this.showSnackbar("#b71c1c", "HomeWork Title is compulsory!");
          return;
        }
        this.overlay = true;
        this.edit_dialog = false;
        let formData = new FormData();

        formData.append("worksheet_id", this.editedItem.worksheet_id);
        formData.append("title", this.editedItem.title);
        formData.append("description", this.editedItem.description);
        formData.append("new_file", this.new_file);
        formData.append("courseoffering_id", this.$store.getters.course_off_id);
        formData.append("ay_id", this.$store.getters.ay_id);
       

        let assessmentTypeValue = this.editedItem.assessmentTypeConfiglist;

        if (Array.isArray(assessmentTypeValue)) {
          // Extract IDs when multiple assessment types are selected
          const assessmentTypeIds = assessmentTypeValue.map(item => (item && typeof item === "object" ? item.id : item));
          formData.append("assessment_type_id", assessmentTypeIds.join(",")); // Send as CSV instead of JSON
        } else if (assessmentTypeValue && typeof assessmentTypeValue === "object" && "id" in assessmentTypeValue) {
          // Single object case
          formData.append("assessment_type_id", assessmentTypeValue.id);
        } else {
          // If it's already a valid ID or empty
          formData.append("assessment_type_id", assessmentTypeValue || "");
        }



        axios
          .post("/Homework/edit_worksheet", formData)
          .then((res) => {
            this.overlay = false;
            if (res.data.flag == "YES") {
              (this.editedItem.title = null),
                (this.editedItem.due_date = null),
                (this.editedItem.description = null),
                (this.editedItem.new_file = null),
                (this.editedItem.model_answer = null),
                (this.editedItem.marks = null),
                this.showSnackbar(
                  "#4caf50",
                  "HomeWork Edited successfully!"
                );
              this.getHomeWorkDetails();
            } if (res.data.flag == "NO") {
              this.showSnackbar("#b71c1c", "Something went wrong!");
            }
            if (res.data.msg == "file_error") {
              this.showSnackbar("#b71c1c", "File not uploaded!");
            }
          })
          .catch((error) => {
            this.overlay = false;
            this.edit_dialog = false;
            let msg = "";
            if (error.response) {
              msg = "Something went wrong.";
            } else if (error.request) {
              msg = "Please try again.";
            } else {
              msg = "Un-expected error.";
            }
          })
          .finally(() => {
            this.overlay = false;
            this.edit_dialog = false;
          });
      } else {

        this.edit_dialog = true;
        this.showSnackbar("#b71c1c", "Worksheet Title is compulsory!");
      }
    },
    deleteAttachment(item) {
      this.delete_load = true;
      const formData = {
        worksheet_id: item.worksheet_id
      }
      axios
        .post("/Homework/delete_worksheet_attachment", formData)
        .then(res => {
          this.not_deleted = res.data.flag
          if (res.data.status == "YES") {
            this.edit_dialog = false;
            this.getHomeWorkDetails();
            this.showSnackbar(
              "#4caf50",
              "Old attachment removed!"
            );

          }
          else if (res.data.status == "NO") {
            this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
            //alert(res.data.status_reason)	
          }
        })
        .catch(error => {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
          window.console.log(error);
        })
        .finally(() => {
          //close loader	
          this.delete_load = false;
        });
    },

    editHomework(item) {
      if (item.attachment != '-') {
        this.not_deleted = true;
      } else {
        this.not_deleted = false;
      }
      this.editedItem = item;
      this.edit_dialog = true;
    },
    formatDate(a, withTime) {
      return withTime
        ? `${a.getFullYear()}-${a.getMonth() + 1
        }-${a.getDate()} ${a.getHours()}:${a.getMinutes()}`
        : `${a.getFullYear()}-${a.getMonth() + 1}-${a.getDate()}`;
    },
    hasWhiteSpace(s) {
      var status = false;
      var reWhiteSpace = new RegExp(/^\s+$/);

      // Check for white space
      if (reWhiteSpace.test(s)) {
        // alert("Please Check Your Fields For Spaces");
        return true;
      }
      return false;
    },
    save() {
      if (this.title != null) {

        if (this.hasWhiteSpace(this.title)) {
          this.showSnackbar("#b71c1c", "HomeWork Title is compulsory!");
          return;
        }
        this.overlay = true;
        this.dialog = false;
        let formData = new FormData();
        formData.append("courseoffering_id", this.$store.getters.course_off_id);
        formData.append("div_off_id", this.$store.getters.div_off_id);
        formData.append("ay_id", this.$store.getters.ay_id);
        formData.append("coi_id", this.$store.getters.coi_id);
        formData.append("title", this.title);
        formData.append("description", this.description);
        formData.append("new_file", this.new_file);
        formData.append("assessment_type", this.assessment_type);
        axios
          .post("/Homework/add_new_worksheet", formData)
          .then((res) => {
            this.overlay = false;
            if (res.data.flag == "YES") {
              (this.title = null),
                (this.description = null),
                (this.new_file = null),
                this.showSnackbar(
                  "#4caf50",
                  "New Worksheet Added successfully!"
                );
              this.getHomeWorkDetails();
            }
            else if (res.data.flag == "No") {
              this.isvalid = res.data.isvalid,
                this.Message = res.data.Message
              this.showSnackbar("red", res.data.Message);
              sessionStorage.setItem("error-trace", res.data.error_trace);
            }
            if (res.data.msg == "file_error") {
              this.showSnackbar("#b71c1c", "File not uploaded!");
              sessionStorage.setItem("error-trace", res.data.error_trace);
            }
            else {
              sessionStorage.setItem("error-trace", res.data.error_trace);
            }
          })
          .catch((error) => {
            this.overlay = false;
            this.dialog = false;
            let msg = "";
            if (error.response) {
              msg = "Something went wrong.";
            } else if (error.request) {
              msg = "Please try again.";
            } else {
              msg = "Un-expected error.";
            }
          })
          .finally(() => {
            this.overlay = false;
            this.dialog = false;
          });
      } else {

        this.dialog = true;
        this.showSnackbar("#b71c1c", "HomeWork Title is compulsory!");
      }
    },
    getHomeWorkDetails() {
      if (
        this.$store.getters.course_off_id == null &&
        this.$store.getters.ay_id == null &&
        this.$store.getters.div_off_id == null
      ) {
        this.$router.push({ name: "add-worksheet" });
      }
      const data = {
        course_offering_id: this.$store.getters.course_off_id,
        ay_id: this.$store.getters.ay_id,
        div_off_id: this.$store.getters.div_off_id,
        coi_id: this.$store.getters.coi_id,
      };
      this.overlay = true;
      axios
        .post("/Homework/fetch_worksheet_data", data)
        .then((res) => {
          this.overlay = false;
          (this.ay = res.data.academic_year),
            (this.standard = res.data.standard),
            (this.division = res.data.division),
            (this.subject = res.data.subject);
          this.worksheets_list = res.data.worksheets_list;
          //this.assessment_type_list = res.data.assessment_type_list;
          this.assessment_type_list = res.data.assessment_type_config_list;
          this.isvalid = res.data.isvalid,
            this.Message = res.data.Message
        })
        .catch((error) => {
          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
        });
    },
    OpenDialog() {
      this.dialog = true;
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
  },
};
</script>

<style scoped>
.mytable /deep/ thead th {
  background: #0f2027 !important;
  /* fallback for old browsers */
  background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027) !important;
  /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(to right, #2c5364, #203a43, #0f2027) !important;
  /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
  background-color: #0f2027 !important;
  color: white !important;
  font-weight: bold !important;
  white-space: nowrap !important;
  text-align: center;
}

.bg {
  background-color: lightseagreen;
  color: white;
}
</style>